/**
 * Le nom sous lequel le navigateur enregistre une pièce reçue du client.
 *
 * L'API rend `nomTelechargement` : le nom à l'extension du type RECONNU par
 * le serveur, jamais celle annoncée par le client. Un fichier « %PDF… » +
 * script déposé sous « arret-maladie.bat » se télécharge en `.pdf`. Sur un
 * objet local (`blob:`), le navigateur prend l'attribut `download`, pas
 * l'en-tête du serveur : c'est donc ICI que la protection atteint le poste de
 * la gestionnaire (verdict QA du 19/09, D2). Absent avec une API plus
 * ancienne : on retombe sur le nom d'origine.
 */
export function nomPourEnregistrer(piece: {
  nom: string;
  nomTelechargement?: string;
}): string {
  return piece.nomTelechargement?.trim() || piece.nom;
}
